var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-tabs-item-mobile",class:_vm.on ? "on" : "",on:{"click":function($event){return _vm.changeTypeId(_vm.info.id)}}},[_vm._v(" "+_vm._s(_vm.$t2(_vm.lang, _vm.info.name, _vm.info.name_en))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }